import { get } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const loadStateTransitions = (documentId, siteId) =>
  get(`${url}/leasingdocument/${documentId}/${siteId}/state-transitions`);

const exp = {
  loadStateTransitions
};
export default exp;